export const TEMPORARY_CLOSURE_ENABLED = true;

export const TEMPORARY_CLOSURE_TITLE = "We're Taking a Temporary Break";

export const TEMPORARY_CLOSURE_MESSAGE = [
    "DeliFeed is a small kitchen run by the two of us. For reasons outside our control, we need to pause the restaurant for a while and won't be able to accept orders during this time.",
    "We hope to be back when we're able, and we'll share an update as soon as we can.",
    "Thank you for supporting us."
] as const;

export const TEMPORARY_CLOSURE_ORDER_ERROR = "DeliFeed is temporarily closed and cannot accept orders right now.";
